module.exports = __webpack_public_path__ + "img/smile.5ba673f2.png";